function setFirebaseindex() {
    console.log("test");
}

function getAllIndex() {
    console.log("test");
}
export { setFirebaseindex, getAllIndex };